import styled from "styled-components";
import { createShouldForwardPropBlockList, deepMerge } from "@components/common/utils/helper";
import { type AlertProps } from "./alert";
import { getBackgroundColor, getBorderColor, getBorderRadius, getColor, getIconBackgroundColor, getIconColor } from "./alert.styles.utils";

type WrapperProps = Pick<AlertProps, "color" | "rounded" | "colorizeOnlyIcon" | "shadow">;
type IconProps = Pick<AlertProps, "color">;

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["color", "rounded", "colorizeOnlyIcon", "shadow"]),
})<WrapperProps>(({ color, rounded, colorizeOnlyIcon, shadow, theme }) => ({
    paddingTop: theme.spacing.px,
    paddingBottom: theme.spacing.px,
    letterSpacing: theme.letterSpacing.normal,
    textTransform: "none",
    borderWidth: theme.borderWidth.DEFAULT,
    borderStyle: "solid",
    ...(shadow && { boxShadow: theme.boxShadow.card }),
    ...deepMerge(
        getBackgroundColor(color, colorizeOnlyIcon, theme),
        getColor(color, colorizeOnlyIcon, theme),
        getBorderRadius(rounded, theme),
        getBorderColor(color, colorizeOnlyIcon, theme),
    ),
}));

export const Body = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing[3],
    paddingLeft: theme.spacing[5],
    paddingRight: theme.spacing[5],
    paddingTop: theme.spacing[3],
    paddingBottom: theme.spacing[3],
}));

export const IconWrapper = styled("div")(({ theme }) => ({
    flexShrink: 0,
    position: "relative",
    width: theme.spacing[6],
    height: theme.spacing[6],
}));

export const Icon = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["color"]),
})<IconProps>(({ theme, color }) => ({
    position: "absolute",
    top: `calc((${theme.fontSize.xs} * var(--default-line-height)) / 2)`,
    translate: "0 -50%",
    width: theme.spacing[6],
    height: theme.spacing[6],
    borderRadius: theme.borderRadius.full,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...deepMerge(getIconBackgroundColor(color, theme)),
    "& svg": {
        width: theme.spacing[3.5],
        height: theme.spacing[3.5],
        ...deepMerge(getIconColor(color, theme)),
    },
}));

export const Message = styled("div")(({ theme }) => ({
    width: "100%",
    fontSize: theme.fontSize.xs,
}));

export const CloseWrapper = styled("div")(({ theme }) => ({
    flexShrink: 0,
    position: "relative",
    width: theme.spacing[6],
    height: theme.spacing[6],
}));
